module.exports = __webpack_public_path__ + "static/img/39.c4a9524.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/39.png
// module id = vvuF
// module chunks = 0